import { Asset } from "app/models/asset";

export class PlannedServiceWork {
    public asset: Asset;
    public finishDate?: Date;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/plannedServiceWork.ts